import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { ZINDEX } from 'shared/constants';
import { useLocalStorage } from 'shared/hooks';
import { Flex } from 'components';
import { OpenButton } from './OpenButton';
import { Coords, BigHex, MiniHex } from './Sections';

export const DevOverlay = () => {
  const [enabled, setEnabled] = useLocalStorage('devOverlay', true);
  const [isDevUIVisible, setIsDevUIVisible] = useState<boolean>(false);

  const enableUI = () => setEnabled(true);
  const disableUI = () => setEnabled(false);
  const onOpenUIClick = () => setIsDevUIVisible(!isDevUIVisible);

  useEffect(() => {
    /* @ts-ignore */
    window.enableUI = enableUI;
    /* @ts-ignore */
    window.disableUI = disableUI;
  }, []);

  return enabled ? (
    <>
      <OpenButton onOpenUIClick={onOpenUIClick} />
      {isDevUIVisible && (
        <DevUI>
          <Coords />
          <BigHex />
          <MiniHex />
        </DevUI>
      )}
    </>
  ) : null;
};

const DevUI = styled(Flex)`
  position: absolute;
  flex-wrap: wrap;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40%;
  background-color: #000000ee;
  z-index: ${ZINDEX.MODAL};
`;
